import { render, staticRenderFns } from "./report-company.vue?vue&type=template&id=5b1fb08f&scoped=true&"
import script from "./report-company.vue?vue&type=script&lang=js&"
export * from "./report-company.vue?vue&type=script&lang=js&"
import style0 from "./report-company.vue?vue&type=style&index=0&id=5b1fb08f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fb08f",
  null
  
)

export default component.exports